import { Account, Identifiable, ProjectResource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource } from "../linkers/types";

type Response = Identifiable<ProjectResource>[];

function getProjectsRoles(httpClient: HttpClient) {
  return ({ resource }: Identifiable<Account>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projectMembers/role-project-mapping?projection=projectRoleMapping&size=99999&embed_links=false`,
        method: HttpMethods.GET,
      })
      .then((projectResources) =>
        projectResources.map((projectResource) => ({
          ...projectResource,
          resource,
        })),
      );
}

export { getProjectsRoles };
